/**
 * Redux action type constants for helpdesk functionality.
 *
 * @module redux/helpdesk/helpdeskTypes
 * @author Snowfly
 * @version 1.0.0
 */
export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_HELPDESK_TICKETS = 'FETCH_HELPDESK_TICKETS';
